module.exports = __webpack_public_path__ + "img/Portal.f0b94b5d.jpg";